import React, { useContext } from "react";
import isEmpty from "lodash/isEmpty";
import loadable from "@loadable/component";
import PageContext from "@PageContext";
import WebProfileContext from "@WebProfileContext";
import ReactMetaData01 from "@micado-digital/react-metadata/ReactMetadata01";

const ReactTracking = loadable(() => import("@micado-digital/react-tracking/ReactTracking"));

const Core = () => {
	const [pageData] = useContext(PageContext);
	const { lang, meta = {} } = pageData;
	const [profileData] = useContext(WebProfileContext);
	const { trackingCodes = [] } = profileData;

	if (isEmpty(pageData)) return <></>;

	const {
		canonical: metaCanonical,
		defaultLang: metaDefaultLang,
		description: metaDescription,
		indexable: metaIndexable,
		image: metaImage,
		keywords: metaKeywords,
		lat: metaLat,
		links: metaLinks,
		lng: metaLng,
		title: metaTitle
	} = meta;

	return (
		<>
			<ReactMetaData01
				canonical={metaCanonical}
				defaultLang={metaDefaultLang}
				description={metaDescription}
				index={metaIndexable}
				image={metaImage}
				keywords={metaKeywords}
				lat={metaLat}
				lang={lang}
				links={metaLinks}
				lng={metaLng}
				title={metaTitle}
			/>
			<ReactTracking codes={trackingCodes} />
		</>
	);
};

export default Core;
